import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-replaced-session-notice',
  templateUrl: './replaced-session-notice.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReplacedSessionNoticeComponent {}
